import { StringMap } from 'types/index';

export const LANGUAGE_NAMES: StringMap = {
  js: 'JavaScript',
  go: 'Golang',
  json: 'JSON',
  curl: 'cURL',
  java: 'Java',
  xml: 'XML',
  py: 'Python',
};

export const MARKDOWN_CONTENT_MAX_WIDTH = '696px';
